// eslint wants to get rid of this, but typescript needs it for our type guard
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
export const disabledSuspenseQueryData = 'disabled-suspense-query-data' as const;
export const disabledSuspenseQuery = {
  queryKey: ['disabled-suspense-query'],
  queryFn: async () => Promise.resolve(disabledSuspenseQueryData),
} as const;
